import {
    Container,
    Divider,
    NavPill,
    OutsideClickHandler,
    Typography
} from '@/src/ct-design/lib'
import MenuItem from '../menuItem'
import {
    isLoggedIn,
    clearAuthCookies,
    getAuthDisplayName,
    isEmpty,
    redirectToVisaSignIn
} from '@/src/utils/helper'
import { CLEARTRIP, DESKTOP } from '@/src/constants'
import { Brand } from '@/src/utils/brand'
import { userSignOut } from '@/src/api/services/userService'
import styles from './userProfile.module.css'

interface UserProfileProps {
    brand: Brand
    showUserMenu: boolean
    setShowUserMenu: (showUserMenu: boolean) => void
}

const UserProfile = ({
    brand,
    showUserMenu,
    setShowUserMenu
}: UserProfileProps) => {
    const signedIn = isLoggedIn()
    const displayName = getAuthDisplayName()
    const isCleartrip = brand === CLEARTRIP
    const menuItems = isCleartrip
        ? [
              { label: 'Trips', url: '/en/trips' },
              { label: 'Travellers', url: '/en/travellers' },
              { label: 'Profile', url: '/en/profile' },
              { label: 'Wallet', url: '/en/wallet' },
              { label: 'Expressway', url: '/accounts/expressway' },
              { label: 'Settings', url: '/account/settings' }
          ]
        : [
              { label: 'My Bookings', url: '/en/trips' },
              { label: 'My Wallet', url: '/en/wallet' },
              { label: 'Profile', url: '/en/profile' },
              { label: 'Travellers', url: '/en/travellers' },
              { label: 'My Reviews', url: '/manageReviews' },
              { label: 'Give Feedback', url: '/feedback' }
          ]

    const handleProfileItemClick = async (url: string) => {
        if (url === '/signout') {
            try {
                await userSignOut(
                    brand === CLEARTRIP ? 'cleartrip' : 'flyin',
                    DESKTOP
                )
            } catch (error) {
                console.error('Logout failed:', error)
            } finally {
                clearAuthCookies()
                setShowUserMenu(false)
                window.location.reload()
            }
            return
        }

        window.open(url, '_blank')
    }
    const handleSignInClick = () => {
        redirectToVisaSignIn()
    }
    return (
        <>
            <Container className='p-relative'>
                <OutsideClickHandler
                    onOutsideClick={() => setShowUserMenu(false)}
                >
                    {signedIn ? (
                        <NavPill
                            onClick={() => {
                                setShowUserMenu(!showUserMenu)
                            }}
                            showIcon={true}
                            type='user'
                            displayValue={displayName}
                        />
                    ) : (
                        <button
                            type='button'
                            className={styles.signInButton}
                            onClick={handleSignInClick}
                        >
                            <Typography
                                variant='P3'
                                className={styles.signInLabel}
                            >
                                Sign In
                            </Typography>
                        </button>
                    )}
                    {showUserMenu && (
                        <Container
                            className='br-4 p-absolute bg-neutral-100 z-100 o-hidden'
                            style={{
                                width: '370px',
                                boxShadow: '0px 8px 24px rgba(26, 26, 26, 0.1)',
                                top: '44px',
                                right: '0',
                                transform: 'translateX(calc(100% - 370px))'
                            }}
                        >
                            <Container className='flex flex-column flex-between flex-middle'>
                                <Container className='fw-600 fs-14 c-neutral-900'>
                                    <Typography variant='B3' className='my-2'>
                                        {!isEmpty(displayName) &&
                                        displayName !== 'null'
                                            ? displayName
                                            : 'Hello'}
                                    </Typography>
                                </Container>
                                <Divider
                                    color='#e6e6e6'
                                    className='my-1 w-100p'
                                    height={1}
                                />
                                <Container className='flex flex-column px-1 py-2 w-100p'>
                                    {menuItems.map((item, index) => (
                                        <MenuItem
                                            key={index}
                                            label={item.label}
                                            onClick={() =>
                                                handleProfileItemClick(item.url)
                                            }
                                            isLink={true}
                                        />
                                    ))}
                                </Container>

                                <Divider
                                    color='#e6e6e6'
                                    className='my-1 w-100p'
                                    height={1}
                                />
                                {signedIn && (
                                    <Container
                                        className='flex flex-right mb-2 mx-2 w-100p'
                                        onClick={() =>
                                            handleProfileItemClick('/signout')
                                        }
                                    >
                                        <Typography
                                            variant='P2'
                                            className='mr-2 c-pointer'
                                            color='warning'
                                        >
                                            Sign out
                                        </Typography>
                                    </Container>
                                )}
                            </Container>
                        </Container>
                    )}
                </OutsideClickHandler>
            </Container>
        </>
    )
}

export default UserProfile
